import { useQuery } from '@tanstack/react-query'
import { getBvnPepper } from '../api'

export const bvnPepperQueryKey = ['blocks', 'bvn-pepper'] as const

/**
 * Fetch the session-bound HMAC pepper used to hash BVNs client-side before
 * submission (per AF-128 technical notes). Cached for the session lifetime
 * — the backend rotates it on login, so a long staleTime is fine.
 *
 * The pepper is *not* a secret the user can see meaningfully on its own;
 * it's a salt that prevents rainbow-table attacks against the hashed BVN.
 */
export function usePepper() {
  return useQuery({
    queryKey: bvnPepperQueryKey,
    queryFn: getBvnPepper,
    staleTime: Infinity,
    gcTime: Infinity,
    select: (data) => data.pepper,
  })
}
